import { Plan } from '@wix/ambassador-pricing-plans-v3-plan/types';

export const EMPTY_PLAN: Plan = {
  id: '',
  name: '',
  pricingVariants: [{}],
};
